import { defineMessages } from 'react-intl'

const scope = `procurify.modules.expense.features.correct-expense-item-account-codes.CorrectExpenseItemAccountCodesForm`

export default defineMessages({
  requesterLabel: {
    id: `${scope}.requesterLabel`,
    defaultMessage: 'Requester',
  },
  submittedLabel: {
    id: `${scope}.submittedLabel`,
    defaultMessage: 'Submitted',
  },
  approvedLabel: {
    id: `${scope}.approvedLabel`,
    defaultMessage: 'Approved',
  },
  applyToAllPrimaryCategoryLabel: {
    id: `${scope}.applyToAllPrimaryCategoryLabel`,
    defaultMessage: 'Apply to all {singularPrimaryOrgCategoryLabel}',
  },
  applyToAllSecondaryCategoryLabel: {
    id: `${scope}.applyToAllSecondaryCategoryLabel`,
    defaultMessage: 'Apply to all {singularSecondaryOrgCategoryLabel}',
  },
  applyToAllAccountLabel: {
    id: `${scope}.applyToAllAccountLabel`,
    defaultMessage: 'Apply to all account code',
  },
  secondaryCategoryRequiredError: {
    id: `${scope}.secondaryCategoryRequiredError`,
    defaultMessage: '{singularSecondaryOrgCategoryLabel} is required',
  },
  accountRequiredError: {
    id: `${scope}.accountRequiredError`,
    defaultMessage: 'Account code is required',
  },
  columnExpenseNumber: {
    id: `${scope}.columnExpenseNumber`,
    defaultMessage: 'Expense #',
  },
  columnReceipt: {
    id: `${scope}.columnReceipt`,
    defaultMessage: 'Receipt',
  },
  columnType: {
    id: `${scope}.columnType`,
    defaultMessage: 'Type',
  },
  columnTotalAmount: {
    id: `${scope}.columnTotalAmount`,
    defaultMessage: 'Total amount',
  },
  columnAccountCode: {
    id: `${scope}.columnAccountCode`,
    defaultMessage: 'Account code',
  },
  columnBudgetDate: {
    id: `${scope}.columnBudgetDate`,
    defaultMessage: 'Budget date',
  },
  budgetDateValue: {
    id: `${scope}.budgetDateValue`,
    defaultMessage: '{status}: {startDate} - {endDate}',
  },
  budgetDateEmpty: {
    id: `${scope}.budgetDateEmpty`,
    defaultMessage: 'N/A',
  },
  budgetStatusActive: {
    id: `${scope}.budgetStatusActive`,
    defaultMessage: 'Active',
  },
  budgetStatusExpired: {
    id: `${scope}.budgetStatusExpired`,
    defaultMessage: 'Expired',
  },
  receiptLinkAriaLabel: {
    id: `${scope}.receiptLinkAriaLabel`,
    defaultMessage: 'Receipt for {label}',
  },
  siblingSectionTitle: {
    id: `${scope}.siblingSectionTitle`,
    defaultMessage: 'Expense #{reportNumber} - Other approved items ({count})',
  },
  siblingAttentionNote: {
    id: `${scope}.siblingAttentionNote`,
    defaultMessage:
      'All expense items in the same request will update to the new selected {singularPrimaryOrgCategoryLabel} / {singularSecondaryOrgCategoryLabel}',
  },
  primaryItemTableAriaLabel: {
    id: `${scope}.primaryItemTableAriaLabel`,
    defaultMessage: 'Approved expense item being corrected',
  },
  siblingItemsTableAriaLabel: {
    id: `${scope}.siblingItemsTableAriaLabel`,
    defaultMessage: 'Other approved items in the same expense report',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  saveChangesButton: {
    id: `${scope}.saveChangesButton`,
    defaultMessage: 'Save changes',
  },
})
